import { Menu } from '@core/modules/layout/interfaces/menu.interface';
import {
    AUDIT_ROUTE,
    AUDIT_ROUTE_CREATE,
    MESSAGES_ROUTE,
    DASHBOARD_ROUTE,
    MATERIAL_ROUTE,
    NON_CONFORMITIES_ROUTE,
    SETTINGS_ACCOUNT_ROUTE,
    SETTINGS_COMPANIES_ROUTE,
    SETTINGS_ORGANIZATIONAL_UNITS_ROUTE,
    SETTINGS_ROUTE,
    SETTINGS_STANDARDS_ROUTE,
    SETTINGS_STANDARDS_TYPES_ROUTE,
    SETTINGS_USERS_ROUTE,
    SUBSCRIPTIONS__LICENSE_ROUTE,
    SUBSCRIPTIONS__SUBSCRIPTION_ROUTE,
    SUPPLIER_ROUTE,
} from '@core/constants/navigation/navigation.const';
import { RolesAll } from '@core/modules/role/constants/roles.const';
import { Roles } from '@core/modules/role/enums/roles.enum';
import { MenuIds } from '@core/modules/layout/enums/menu-ids.enum';
import { LicenseModules } from '@core/modules/license/enums/license-module.enum';

export const MENU: Menu[] = [
    {
        id: MenuIds.Dashboard,
        icon: 'lnr lnr-home',
        name: 'Strona główna',
        link: DASHBOARD_ROUTE,
        roles: RolesAll,
    },
    {
        id: MenuIds.AuditCreate,
        icon: 'lnr lnr-plus-circle',
        name: 'Nowy audyt',
        link: AUDIT_ROUTE_CREATE,
        roles: [Roles.Agent, Roles.Auditor, Roles.AuditorVerifier],
    },
    {
        id: MenuIds.AuditList,
        icon: 'lnr lnr-list',
        name: 'Przeglądaj audyty',
        link: AUDIT_ROUTE,
        roles: [Roles.Agent, Roles.Auditor, Roles.AuditorVerifier],
    },
    {
        id: MenuIds.NonConformities,
        icon: 'lnr lnr-warning',
        name: 'Niezgodności',
        link: NON_CONFORMITIES_ROUTE,
        roles: [Roles.Agent, Roles.Auditor, Roles.AuditorVerifier],
        modules: [LicenseModules.NonConformities]
    },
    {
        id: MenuIds.Suppliers,
        icon: 'lnr lnr-store',
        name: 'Dostawcy',
        link: SUPPLIER_ROUTE,
        roles: [Roles.Agent, Roles.AuditorVerifier, Roles.Verifier],
        modules: [LicenseModules.Evaluation]
    },
    {
        id: MenuIds.Materials,
        icon: 'lnr lnr-cart',
        name: 'Surowce',
        link: MATERIAL_ROUTE,
        roles: [Roles.Agent, Roles.AuditorVerifier, Roles.Verifier],
        modules: [LicenseModules.Evaluation]
    },
    {
        id: MenuIds.Messages,
        icon: 'lnr lnr-envelope',
        name: 'Wiadomości',
        link: MESSAGES_ROUTE,
        roles: [Roles.Admin],
    },
    {
        id: MenuIds.Settings,
        icon: 'lnr lnr-cog',
        name: 'Ustawienia',
        link: SETTINGS_ROUTE,
        roles: RolesAll,
        children: [
            {
                id: MenuIds.SettingsAccount,
                icon: 'lnr lnr-user',
                name: 'Ustawienia konta',
                link: SETTINGS_ACCOUNT_ROUTE,
                roles: RolesAll,
            },
            {
                id: MenuIds.SettingsUsers,
                icon: 'lnr lnr-users',
                name: 'Auditorzy',
                link: SETTINGS_USERS_ROUTE,
                roles: [Roles.Admin, Roles.Agent],
            },
            {
                id: MenuIds.SettingsCompanies,
                icon: 'lnr lnr-apartment',
                name: 'Firmy',
                link: SETTINGS_COMPANIES_ROUTE,
                roles: [Roles.Admin],
            },
            {
                id: MenuIds.SettingsOrganizationalUnits,
                icon: 'lnr lnr-layers',
                name: 'Jednostki organizacyjne',
                link: SETTINGS_ORGANIZATIONAL_UNITS_ROUTE,
                roles: [Roles.Agent, Roles.Admin],
            },
            {
                id: MenuIds.SettingsStandardsTypes,
                icon: 'lnr lnr-book',
                name: 'Typy standardów',
                link: SETTINGS_STANDARDS_TYPES_ROUTE,
                roles: [Roles.Admin, Roles.Agent],
            },
            {
                id: MenuIds.SettingsStandards,
                icon: 'lnr lnr-license',
                name: 'Standardy',
                link: SETTINGS_STANDARDS_ROUTE,
                roles: [Roles.Admin, Roles.Agent],
            },
            {
                id: MenuIds.Subscriptions,
                icon: 'lnr lnr-license',
                name: 'Subskrypcje',
                link: SUBSCRIPTIONS__SUBSCRIPTION_ROUTE,
                roles: [Roles.Admin],
            },
            {
                id: MenuIds.SubscriptionsLicense,
                icon: 'lnr lnr-license',
                name: 'Licencja',
                link: SUBSCRIPTIONS__LICENSE_ROUTE,
                roles: [Roles.Agent, Roles.Auditor, Roles.AuditorVerifier, Roles.Verifier],
            }
        ]
    },
];
